import {routes} from './routes';

export * from './roles';
export * from './routes';
export * from './adStatuses';
export * from './externalLinks';
export * from './metrics';

export const RESEND_CODE_TIME_INTERVAL = 30; // in seconds
export const redirectToPath = routes.HOME.path;